import BaseStore from './BaseStore';
import rp from 'request-promise';
import config from '../config';
import { getToken } from '../components/Token';
import { getTenantHeaders } from '../components/TenantHeaders';

export class SmartwatchStore extends BaseStore {
  constructor() {
    super();
    this.observable({
      smartWatchAccounts: [],
      smartWatchDevices: [],
      accountPatient: [],
      smartWatchAccountList: [],
      loading: false,
      loadingAuth: false,
    });
  }

  setData() {
    this.smartWatchAccounts = [];
    this.smartWatchDevices = [];
    this.accountPatient = [];
  }

  async getAllAccounts(queryOption) {
    this.loading = true;
    try {
      let url = `${config.api.url}/${config.api.version}/smartwatch/account`;
      const res = await rp
        .get(url, {
          qs: queryOption,
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res.statusCode === 200) {
        const accounts = res.body || null;
        this.smartWatchAccounts = accounts;
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async getAccountByPatientId(id) {
    this.loading = true;
    try {
      let url = `${config.api.url}/${config.api.version}/smartwatch/account/${id}`;
      const res = await rp
        .get(url, {
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res.statusCode === 200) {
        const data = res.body || null;
        const tmp = [];
        if (data && data.account) {
          tmp.push(data.account);
        }
        this.accountPatient = tmp;
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async assignPatientAccount(patientId, accountId) {
    this.loading = true;
    try {
      const detail = {
        patientId,
        accountId,
      };
      let url = `${config.api.url}/${config.api.version}/smartwatch/patient/assigned/account`;
      const res = await rp
        .post(url, {
          body: detail,
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res.statusCode === 200) {
        return res;
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async unAssignPatientAccount(patientId) {
    this.loading = true;
    try {
      const detail = {
        patientId,
      };
      let url = `${config.api.url}/${config.api.version}/smartwatch/patient/unassigned/account`;
      const res = await rp
        .post(url, {
          body: detail,
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res.statusCode === 200) {
        this.accountPatient = [];
        return true;
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async createSmartwatchAccount(data) {
    this.loading = true;
    try {
      const detail = {
        username: data.username,
        brand: data.brand,
        description: data.description,
        userAccessToken: data.userAccessToken,
        userAccessTokenSecret: data.userAccessTokenSecret,
        tenantId: data.tenantId,
      };
      const res = await rp
        .post(`${config.api.url}/${config.api.version}/smartwatch/account`, {
          body: detail,
          json: true,
          authorization: true,
          resolveWithFullResponse: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        return res;
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async updateSmartwatchAccount(data) {
    this.loading = true;
    try {
      const detail = {
        username: data.username,
        brand: data.brand,
        description: data.description,
        userAccessToken: data.userAccessToken,
        userAccessTokenSecret: data.userAccessTokenSecret,
      };
      const res = await rp
        .put(`${config.api.url}/${config.api.version}/smartwatch/account/${data.accountId}`, {
          body: detail,
          json: true,
          authorization: true,
          resolveWithFullResponse: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        return res;
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async getAllSmartwatchDevices(queryOption) {
    this.loading = true;
    try {
      let url = `${config.api.url}/${config.api.version}/smartwatch/device`;
      const res = await rp
        .get(url, {
          qs: queryOption,
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res.statusCode === 200) {
        const devices = res.body || null;
        this.smartWatchDevices = devices;
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async createSmartwatchDevice(data) {
    this.loading = true;
    try {
      const detail = {
        name: data.name,
        serial: data.serial,
        brand: data.brand,
        model: data.model,
        purchasedDate: data.purchasedDate,
        description: data.description,
      };
      const res = await rp
        .post(`${config.api.url}/${config.api.version}/smartwatch/device`, {
          body: detail,
          json: true,
          authorization: true,
          resolveWithFullResponse: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        return res;
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async updateSmartwatchDevice(data) {
    this.loading = true;
    try {
      const detail = {
        name: data.name,
        serial: data.serial,
        brand: data.brand,
        model: data.model,
        purchasedDate: data.purchasedDate,
        description: data.description,
      };
      const res = await rp
        .put(`${config.api.url}/${config.api.version}/smartwatch/device/${data.id}`, {
          body: detail,
          json: true,
          authorization: true,
          resolveWithFullResponse: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        return res;
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async deleteSmartwatchDevice(id) {
    this.loading = true;
    try {
      const res = await rp
        .delete(`${config.api.url}/${config.api.version}/smartwatch/device/${id}`, {
          json: true,
          authorization: true,
          resolveWithFullResponse: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        return res;
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async assignDeviceAccount(accountId, deviceIds) {
    this.loading = true;
    try {
      const detail = {
        accountId,
        deviceIds,
      };
      let url = `${config.api.url}/${config.api.version}/smartwatch/account/assigned/device`;
      const res = await rp
        .post(url, {
          body: detail,
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res.statusCode === 200) {
        return res;
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async unAssignDeviceAccount(accountId, deviceIds) {
    this.loading = true;
    try {
      const detail = {
        accountId,
        deviceIds,
      };
      let url = `${config.api.url}/${config.api.version}/smartwatch/account/unassigned/device`;
      const res = await rp
        .post(url, {
          body: detail,
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res.statusCode === 200) {
        return res;
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async testAuthenForAccount(accountId) {
    this.loadingAuth = true;
    try {
      let url = `${config.api.url}/${config.api.version}/smartwatch/account/validate/${accountId}`;
      const res = await rp
        .get(url, {
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res.statusCode === 200) {
        return res;
      }
    } catch (err) {
      throw err;
    } finally {
      this.loadingAuth = false;
    }
  }
}
export default new SmartwatchStore();
